// extracted by mini-css-extract-plugin
module.exports = {"container":"panelBlock_container__3KprU","iconColor":"panelBlock_iconColor__3eenM","textContainer":"panelBlock_textContainer___5prW","bold":"panelBlock_bold__31bOa"};